import FlagType from 'owa-service/lib/contract/FlagType';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
import { lazyApplyConversationFlagInReadingPane } from 'owa-mail-reading-pane-store';
import {
    ApplyConversationFlagStateStoreUpdateActionName,
    ApplyConversationFlagStateStoreUpdate,
} from 'owa-mail-store-actions';

export default function subscribeToApplyConversationFlaggedStateStitch() {
    subscribe<ApplyConversationFlagStateStoreUpdate>(
        ApplyConversationFlagStateStoreUpdateActionName,
        (conversationIds: string[], flagType: FlagType, tableViewId: string) => {
            lazyApplyConversationFlagInReadingPane.importAndExecute(
                conversationIds,
                flagType,
                tableViewId
            );
        }
    );
}
